export default __webpack_public_path__ + "static/media/remainder-icon.fd8c093c.svg";